export interface ShuffleDto
{
    getAPartyMsisdn():string;
    getLanguage():string;
    getIdentifier():string;
}

export class ShuffleDtoImpl implements ShuffleDto
{
    private aPartyMsisdn:string;
    private language:string;
    private identifier:string;


    setAPartyMsisdn(aPartyMsisdn:string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn():string
    {
        return this.aPartyMsisdn;
    }

    setLanguage(language:string)
    {
        this.language = language;
    }
    getLanguage():string
    {
        return this.language;

    }

    setIdentifier(identifier:string)
    {
        this.identifier = identifier;
    }

    getIdentifier():string
    {
        return this.identifier;
    }



    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/shuffle/shufflesdto.ts